export enum logger {
  chatPro = 'chatProRender',
  lazyComponent = 'lazyComponent',
  inputWrapper = 'inputWrapper',
  autoComplete = 'autoComplete',
}
